import React from 'react'
import "./color.css"

function OrangeHC() {
    var x = localStorage.getItem("percentage hc")

    return (
        <div className = "orange__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default OrangeHC